<template>
    <div class="container-2fa">
        <!--  <header>
            <img src="@/assets/images/logo-tecmor.jpg" alt="">
        </header> -->

        <div class="container-cards">
            <v-card width="700px" :elevation="8">
                <div class="pa-4">
                    <div class="text-center">
                        <img src="@/assets/images/two-factor-authentication.png" alt="Login" class="icon-2fa">
                    </div>
                    <div class="title">Autenticación en 2 Pasos</div>
                    <v-stepper v-model="step" alt-labels>
                        <v-stepper-header>
                            <v-stepper-item
                                title="Instalar App"
                                :value="1"
                                :complete="step > 1" editable
                            >
                            </v-stepper-item>
                            <v-divider></v-divider>
                            <v-stepper-item
                                title="Escanear Código"
                                :value="2"
                                :complete="step > 2"
                                editable
                            >
                            </v-stepper-item>
                            <v-divider></v-divider>
                            <v-stepper-item
                                :complete="step > 3"
                                :value="3"
                                title="Verificar Código"
                                editable
                            >
                            </v-stepper-item>
                        </v-stepper-header>
                        <v-stepper-window>
                            <v-stepper-window-item :value="1">
                                <v-card height="350" key="step-1-card">
                                    <v-row class="text-h6 text-center mt-4 mb-2 text-h8 step-title-wrap">
                                        Use su celular para escanear el código QR y descargar la aplicación Google Authenticator.
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="d-flex flex-column align-center">
                                            <img src="@/assets/images/google-auth-app.webp" alt="google authenticator" style="width: 30px;">
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="4" class="d-flex flex-column align-center">
                                            <img :src="qrAppStore" alt="App Store QR" style="max-width:120px;" />
                                            <span class="mt-2 image-title-2fa">App Store</span>
                                        </v-col>
                                        <v-col cols="4" class="d-flex flex-column align-center">
                                            <img :src="qrPlayStore" alt="Google Play"
                                                style="max-width:120px;" />
                                            <span class="mt-2 image-title-2fa">Play Store</span>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-stepper-window-item>
                            <v-stepper-window-item :value="2">
                                <v-card height="350" key="step-2-card">
                                    <v-card-title class="text-h6 text-center mb-4">
                                        Genere y escanee el código QR con la aplicación.
                                    </v-card-title>
                                    <v-row v-if="qrUser" justify="center">
                                        <img :src="qrUser" alt="User QR" style="max-width:200px;" />
                                    </v-row>
                                    <v-row v-else justify="center">
                                        <v-btn class="btn-2fa" @click="generateCode()">Generar Código</v-btn>
                                    </v-row>
                                </v-card>
                            </v-stepper-window-item>
                            <v-stepper-window-item :value="3">
                                <v-card height="350" key="step-3-card">
                                    <v-card-title class="text-h6 text-center mb-4">
                                        Ingresa el código generado por la aplicación
                                    </v-card-title>
                                    <v-otp-input :loading="validatingCode" v-model="otpValue"></v-otp-input>
                                    <v-row justify="center" class="mt-2">
                                        <v-btn class="btn-2fa" @click="validateCode()" :disabled="validatingCode || !/^[0-9]{6}$/.test(otpValue)">Validar Código</v-btn>
                                    </v-row>
                                </v-card>
                            </v-stepper-window-item>
                        </v-stepper-window>
                        <v-stepper-actions
                            @click:next="nextStep"
                            @click:prev="prevStep"
                            next-text="Siguiente"
                            prev-text="Anterior"
                        >
                        </v-stepper-actions>
                    </v-stepper>
                </div>
                <v-card-actions>
                    <v-btn @click="logout()">
                        <img src="@/assets/images/item-menu-cerrar-sesion.png" alt="Cerrar Sesión"
                            style="width: 24px; height: 24px;">
                        Cerrar Sesión
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <Footer />
    </div>
    <Footer class="content_footer" :elevation="10" />
</template>

<script>
import Footer from '../../components/Footer.vue'

import QRCode from 'qrcode'
import { LoginService } from '@/services/LoginService'
import { useAuthStore } from '@/stores/auth'

export default {
    name: 'Setup2FA',
    components: {
        Footer,
    },
    data() {
        return {
            step: 1,
            qrAppStore: '',
            qrPlayStore: '',
            qrUser: '',
            validatingCode: false,
            otpValue: '',
        }
    },
    methods: {
        nextStep() {
            this.step++;
        },
        prevStep() {
            this.step--;
        },
        async validateCode() {
            const authStore = useAuthStore();
            this.validatingCode = true;
            try {
                
                const response = await LoginService.validate2FA(this.otpValue);
                if (response && !response.error) {
                    localStorage.setItem('TOKEN', response.response.token);
                    // Navigate to the main application page
                    authStore.setTwoFAStatus('VALIDATED');
                    localStorage.setItem('TOKEN', response.response.token);
                    this.$router.push('/SGCCV');
                } else {
                    alert('Código inválido. Inténtalo de nuevo.');
                }
            } catch (error) {
                console.error('Error validating 2FA code:', error);
                alert('Ocurrió un error al validar el código. Inténtalo de nuevo.');
            } finally {
                this.validatingCode = false;
            }
        },
        async generateCode() {
            try {
                const response = await LoginService.get2FACode();
                console.log(response.response);
                this.qrUser = response.response.qrCode;
            } catch (error) {
                console.error('Error generating 2FA code:', error);
            }
        },
        logout: function () {
            const authStore = useAuthStore();
            authStore.logout();
            this.$router.push('/login')
        },
    },
    mounted() {
        // Replace with your actual App Store URL
        const appStoreUrl = 'https://apps.apple.com/es/app/google-authenticator/id388497605';
        QRCode.toDataURL(appStoreUrl, { width: 120, margin: 1 }, (err, url) => {
            if (!err) {
                this.qrAppStore = url;
            }
        });
        const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
        QRCode.toDataURL(playStoreUrl, { width: 120, margin: 1 }, (err, url) => {
            if (!err) {
                this.qrPlayStore = url;
            }
        });
        
    }
}
</script>

<style scoped>
.container-2fa {
    height: 100vh;
    background-image: url("@/assets/images/background.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.title-2fa {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 1.2;
    font-size: 20pt;
    font-weight: 400;
    padding-bottom: 20px;
}

.image-title-2fa {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    display: block;
    text-align: center;
    width: 100%;
    font-size: 15pt;
}

.container-cards {
    padding-left: 15%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 95vh;
}

.icon-2fa {
    height: 45px;
}

.title {
    text-align: center;
    font-size: 20px;
}

form {
    margin: 30px 0 10px 0;
}

.btn-2fa {
    background-color: #007BFF;
    color: #FFFFFF;
}

footer {
    height: 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading {
    text-align: center;
}
</style>